package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.AuthRepository

class LoginWithGoogleUseCase(
    private val authRepository: AuthRepository
) {
    suspend operator fun invoke(): Result<Unit> {
        return authRepository.loginWithGoogle()
    }
}
